import { Component, HostListener, input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { AuthStore } from '../../../store/auth';
import { IUser } from '../../../models/index';
import { UiStore } from '../../../store/ui';
import { TranslateModule } from '@ngx-translate/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'lib-navbar',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './navbar.component.html',
})
export class NavbarComponent implements OnInit, OnDestroy {
  showNotificationsDropdown = false;
  showUserDropdown = false;
  companyLogoUrl = input<string | null>('public/shared/images/logos/isotipo.svg');
  userData = <IUser>{};
  pageTitle = '';
  private _destroy$ = new Subject<void>();

  // Escuchar clics en el documento para cerrar los dropdowns si se hace clic fuera
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    // Si el clic no es en los botones de toggle ni dentro de los dropdowns, ciérralos
    if (!target.closest('.notifications-button') && !target.closest('.notifications-dropdown')) {
      this.showNotificationsDropdown = false;
    }
    if (!target.closest('.user-button') && !target.closest('.user-dropdown')) {
      this.showUserDropdown = false;
    }
  }
  constructor(
    private _store: Store,
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.pageTitle = this._getCurrentRouteTitle(this._activatedRoute.root);
    });

    // Inicial (cuando recarga la página)
    this.pageTitle = this._getCurrentRouteTitle(this._activatedRoute.root);

    this._store
      .select(AuthStore.selectors.selectUser)
      .pipe(takeUntil(this._destroy$))
      .subscribe((user) => {
        if (user) {
          this.userData = user;
        }
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  getInitials(name?: string, lastName?: string): string {
    const n = name?.trim()?.charAt(0) ?? '';
    const l = lastName?.trim()?.charAt(0) ?? '';
    return (n + l).toUpperCase();
  }

  private _getCurrentRouteTitle(route: ActivatedRoute): string {
    let currentRoute: ActivatedRoute | null = route.firstChild;
    let title = '';

    while (currentRoute) {
      if (currentRoute.outlet === 'primary') {
        const routeSnapshot = currentRoute.snapshot;
        const routeTitle = routeSnapshot.data['title'] || routeSnapshot.data['breadcrumb'];

        if (routeTitle) {
          title = routeTitle;
        }
      }
      currentRoute = currentRoute.firstChild;
    }

    return title;
  }

  toggleNotificationsDropdown(event: MouseEvent): void {
    event.stopPropagation(); // Evitar que el document:click se active inmediatamente
    this.showNotificationsDropdown = !this.showNotificationsDropdown;
    if (this.showNotificationsDropdown) {
      this.showUserDropdown = false; // Cerrar el otro dropdown si está abierto
    }
  }

  toggleUserDropdown(event: MouseEvent): void {
    event.stopPropagation(); // Evitar que el document:click se active inmediatamente
    this.showUserDropdown = !this.showUserDropdown;
    if (this.showUserDropdown) {
      this.showNotificationsDropdown = false; // Cerrar el otro dropdown si está abierto
    }
  }

  onLogout(): void {
    this._store.dispatch(AuthStore.actions.logout());
    this.showUserDropdown = false; // Cerrar dropdown después de la acción
  }

  onMenuButtonClick(): void {
    this._store.dispatch(UiStore.actions.toggleSidebar());
  }
}
